/**
 *
 * @module entry
 * @desc {SDK.Configuration} entry point.
 *
 */

import ConfigurationManager from './configurationManager';
import EmbeddedConfiguration from './embeddedConfiguration';
/**
 *
 * @typedef SDK.Configuration
 * @type {Object}
 *
 * @property {ConfigurationManager} ConfigurationManager
 * @property {EmbeddedConfiguration} EmbeddedConfiguration
 *
 */

/**
 *
 * @type {SDK.Configuration}
 *
 */
export default {

    ConfigurationManager,
    EmbeddedConfiguration

};



// WEBPACK FOOTER //
// ./src/configuration/entry.js